import { useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

const TokenRedirect = () => {

    const {tenant,token} = useParams();
    const navigate = useNavigate();
    const localToken = localStorage.getItem('token')

    const tokenHandler = async() => {
        localStorage.setItem('token', token);
        localStorage.removeItem('user');
        localStorage.removeItem('userCurrentTs');
        navigate(`/${tenant}/dashboard`);
    }

    useEffect(() => {
        console.log('localToken correct:',localToken,token);
        if(localToken){
            if(localToken !== token){
                console.log('localToken:',localToken,token);
                tokenHandler();
            }else{
                tokenHandler();
            }
        }else{
            tokenHandler();
        }
       // localStorage.clear();

        // setTimeout(() => {
        //         tokenHandler();
        // }, 1500);

    },[]);
    
    return (
        <div>REDIRECT TO SALES DASHBORD...</div>
    )

}

export default TokenRedirect
